import type { vOutput } from '../validation/index.ts'
import {
  vBoolean,
  vEmail,
  vObject,
  vOptional,
  vString,
} from '../validation/schema/core.ts'

export const shareQuoteRequestSchema = vObject({
  email: vEmail,
  all: vOptional(vBoolean()),
  shipper: vOptional(vString()),
})

export type ShareQuoteRequestDto = vOutput<typeof shareQuoteRequestSchema>
